import fetch from 'unfetch'
import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { InMemoryCache, defaultDataIdFromObject } from 'apollo-cache-inmemory'
import { getGraphqlEndpointUrl } from '@/config/paths'

const cache = new InMemoryCache({
  // By default, the InMemoryCache attempts to generate a unique identifier for an object
  // by combining the object's __typename field with its id or _id field.
  // In dataIdFromObject you can overwrite default behaviour for certain types.
  dataIdFromObject: object => {
    switch (object.__typename) {
      case 'Order':
        return `Order:${object.number}`
      case 'OrderItem':
        return `OrderItem:${object.variantId}`
      default:
        return defaultDataIdFromObject(object)
    }
  },
})

const client = new ApolloClient({
  link: new HttpLink({ uri: getGraphqlEndpointUrl(), fetch }),
  cache,
  headers: {
    'On-Client': 'frontend',
    'Content-Type': 'application/json',
  },
})

export default client
